/**
* @name: role-panel-body
* @author: weiyong
* @date: 2023-02-21 23:47
* @description：role-panel-body
* @update: 2023-02-21 23:47
*/
<template>
  <div class="role-panel-body wh100b">
    <div class="top-cell">
      <div class="row-item-record" :key="index" @click="selRecord(rowItem)" v-for="(rowItem,index) in roleList">
        <div class="row-record flex-div" :class="rowItem.id===curActiveId?'active':'noActive'">
          <div style="padding-left: 8px">{{ index + 1 }}</div>
          <div style="padding-left: 12px;">{{ rowItem.roleName }}</div>
        </div>
      </div>
    </div>
    <a-divider style="border-top: 1px solid #dfdfdf;position: relative;">
      <span class="user-bar-line">{{ t("用户信息") }}</span>
      <div><a-input :placeholder="t('请输入用户名')" size="small" style="z-index:9999;position: absolute;left:12px;top:20px;padding:0 12px;width: 180px;" v-model:value="searchUserName"/></div>
      <a-button v-if="multiple||multiple==='true'" @click="selAll" size="small" type="primary" style="z-index:9999;position: absolute;right:89px;top:20px;padding:0 12px;">{{ t('全选') }}</a-button>
      <a-button v-if="multiple||multiple==='true'" @click="selNotAll" size="small" style="z-index:9999;position: absolute;right:20px;top:20px;padding:0 12px;">{{ t('反选') }}</a-button>
    </a-divider>
    <div class="bottom-cell">
      <search-user-panel-body 
        ref="useSelPanelRef"
        :total="total"
        :pageSize="pageSize"
        :current="current"
        :alreadySelUsers="alreadySelUsers"
        :searchUserList="searchUserList"
        @selItemRecord="selItemRecord"
        @onShowSizeChange="onShowSizeChange"
      />
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {useI18n} from "vue-i18n";

export default defineComponent({
  components: {},
  name: "role-panel-body",
});
</script>

<script lang="ts" setup>
import {useRoleSel} from "../hooks/useRoleSel";
import SearchUserPanelBody from "../panelBody/search-user-panel-body.vue";
import {Tree as aTree, Divider as aDivider, Table as aTable, Input as aInput, Button as aButton} from "ant-design-vue";
import type {TreeProps} from 'ant-design-vue';

const {t} = useI18n()
const props=defineProps({
  roleName: {},
  alreadySelUsers:{},
  multiple:{},
});
const {roleName,alreadySelUsers}=toRefs(props);

const {
  roleList,
  expandedKeys,
  searchUserList,
  selRecord,
  columns,
  curActiveId,
  total,
  onShowSizeChange,
  pageSize,
  current,
} = useRoleSel(alreadySelUsers,roleName);
const emits = defineEmits(['selItemRecord']);
/**
 * 选择记录
 */
const selItemRecord = function ({item}) {
  emits('selItemRecord', {item});
}
const selectedKeys = ref<string[]>([]);

const useSelPanelRef = ref(null);
const selAll = function (){
  useSelPanelRef.value?.selAll();
}
const selNotAll = function (){
  useSelPanelRef.value?.selNotAll();
}
const searchUserName = ref('');
watch(() => unref(searchUserName), (val) => {
  unref(searchUserList).forEach((itemObj) => {
    if(itemObj.realName.indexOf(val) >= 0){
      itemObj.showFlag = true;
    }else{
      itemObj.showFlag = false;
    }
  })
})


</script>

<style type="text/css" lang="less">
.role-panel-body {
  height: calc(100% - 48px);

  .user-bar-line{
    font-size: 14px; color: #888;
    font-weight: 500;
  }

  .row-record {
    border-bottom: 1px solid #eee;
    padding: 8px 14px;

    &:hover {
      background-color: #F1F3F4;
      cursor: pointer;
    }

    &.active {
      background-color: #F1F3F4;
    }
  }

  .top-cell {
    height: calc((80vh - 130px) / 2);
    overflow: auto;
  }

  .bottom-cell {
    height: calc((80vh - 130px) / 2);
    overflow: auto;
  }
}

</style>
